// extracted by mini-css-extract-plugin
export default {"container":"NotificationCounter_container__mTM0Q"};